import React from 'react'
import ChangeOfInstNameAppDtls from './ChangeOfInstNameAppDtls'

export default function ChangeOfInstName() {
    return (
        <div>
            <ChangeOfInstNameAppDtls/>
        </div>
    )
}
